<template>
  <div>
    <b-row>
      <b-col :cols="leftLarge ? 8 : 4">
        <b-row>
          <b-col>
            <h5>
              {{ trans('amilia_live_list') }}
              <small class="text-muted">
                <i class="fa fa-fw fa-info-circle" id="import_from_amilia_about"></i>
                <b-tooltip target="import_from_amilia_about" triggers="hover">
                  {{ trans('import_from_amilia_about') }}
                </b-tooltip>
              </small>
            </h5>
          </b-col>
          <b-col class="col-auto text-right">
            <b-button variant="link" class="p-0" @click="leftLarge = !leftLarge">
              <i :class="'fa fa-fw fa-angle-double-' + (leftLarge ? 'left' : 'right')"></i>
            </b-button>
          </b-col>
        </b-row>

        <b-card footer-tag="footer" class="mb-4" no-body>
          <b-tabs card>
            <b-tab :title="'1. '+trans('import')">
              <div>
                <b-form-group>
                  <b-form-select
                    v-model="selectedProgramId"
                    v-on:change="onProgramChange(undefined)"
                    :options="programs"
                    :disabled="isLoading"
                  />
                </b-form-group>
                <b-form-group>
                  <treeselect
                    id="treeselect"
                    :multiple="true"
                    :clearable="false"
                    :openDirection="hide_extra_rules ? 'below' : 'above'"
                    :options="treeOptions"
                    disable-fuzzy-matching
                    :placeholder="treeTitle"
                    :disabled="isLoading"
                    v-model="treeSelection"
                    v-on:input="filterParticipants"
                  >
                    <div slot="before-list">
                      <b-row class="border-bottom">
                        <b-col class="font-italic">
                          <a class="ml-2" href="#" @click.prevent="onTreeSelectAll()">
                            <small>{{ trans('select_all') }}</small>
                          </a>
                        </b-col>
                        <b-col class="text-right font-italic">
                          <a class="mr-2" href="#" @click.prevent="onTreeClearAll()">
                            <small>{{ trans('unselect_all') }}</small>
                          </a>
                        </b-col>
                      </b-row>
                    </div>
                    <div slot="option-label" slot-scope="{ node }">
                      <span :title="node.raw.title">{{ node.label }}</span>
                    </div>
                  </treeselect>
                </b-form-group>
                <b-form-group>
                  <b-form-radio-group
                    v-model="registration_status"
                    :options="registrationStatusOptions"
                    @input="onRegistrationStatusChange(undefined)"
                    class="ml-1"
                  />
                </b-form-group>
                <div v-for="rule in extra_rules" v-bind:data="rule" v-bind:key="rule.index">
                  <b-row>
                    <b-col>
                      <label><small><strong>{{ trans(rule.type+'_participants') }}</strong></small></label>
                    </b-col>
                    <b-col class="col-auto text-right">
                      <button class="btn btn-sm btn-link text-danger" v-on:click="deleteRule(rule.index)" :title="trans('delete_rule')">
                        <i class="fa fa-fw fa-times"></i>
                      </button>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <b-form-select
                      v-model="rule.selectedProgramId"
                      v-on:change="onProgramChange(rule.index)"
                      :options="programs"
                      :disabled="isLoading"
                    />
                  </b-form-group>
                  <b-form-group>
                    <treeselect
                      :multiple="true"
                      :clearable="false"
                      openDirection="above"
                      :options="rule.treeOptions"
                      disable-fuzzy-matching
                      :placeholder="treeTitle"
                      :disabled="isLoading"
                      v-model="rule.treeSelection"
                      v-on:input="filterParticipants"
                    >
                      <div slot="before-list">
                        <b-row class="border-bottom">
                          <b-col class="font-italic">
                            <a class="ml-2" href="#" @click.prevent="onTreeSelectAll(rule.index)">
                              <small>{{ trans('select_all') }}</small>
                            </a>
                          </b-col>
                          <b-col class="text-right font-italic">
                            <a class="mr-2" href="#" @click.prevent="onTreeClearAll(rule.index)">
                              <small>{{ trans('unselect_all') }}</small>
                            </a>
                          </b-col>
                        </b-row>
                      </div>
                      <div slot="option-label" slot-scope="{ node }">
                        <span :title="node.raw.title">{{ node.label }}</span>
                      </div>
                    </treeselect>
                  </b-form-group>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="rule.registration_status"
                      :options="registrationStatusOptions"
                      @input="onRegistrationStatusChange(rule.index)"
                      class="ml-1"
                    />
                    <small class="text-form text-muted text-right">
                      {{ ruleHelpText(rule) }}
                    </small>
                  </b-form-group>
                </div>
              </div>

              <div v-if="!hide_extra_rules">
                <b-button variant="outline-primary" size="sm" :title="trans('add_participants')" :disabled="!canFilter" v-on:click="onNewAddParticipantsRule">
                  <i class="fa fa-fw fa-plus"></i>
                  <i class="fa fa-fw fa-users"></i>
                </b-button>
                <b-button variant="outline-primary" size="sm" :title="trans('remove_participants')" :disabled="!canFilter" v-on:click="onNewRemoveParticipantsRule" class="ml-4">
                  <i class="fa fa-fw fa-minus"></i>
                  <i class="fa fa-fw fa-users"></i>
                </b-button>
              </div>

              <div class="mt-3">
                <b-form-group>
                  <label><strong>{{ trans('combine_options') }}</strong></label>
                  <div v-if="!amilia_combine && !amilia_allow_multiple">
                    {{ trans('import_single_activity') }}
                    <small class="text-muted" :title="trans('import_single_activity_about')" v-b-tooltip.hover>
                      <i class="fa fa-fw fa-info-circle"></i>
                    </small>
                  </div>
                  <div v-if="amilia_combine && !amilia_allow_multiple">
                    {{ trans('import_combine_duplicates') }}
                    <small class="text-muted" :title="trans('import_combine_duplicates_about')" v-b-tooltip.hover>
                      <i class="fa fa-fw fa-info-circle"></i>
                    </small>
                  </div>
                  <div v-if="!amilia_combine && amilia_allow_multiple">
                    {{ trans('import_allow_multiple_activity') }}
                    <small class="text-muted" :title="trans('import_allow_multiple_activity_about')" v-b-tooltip.hover>
                      <i class="fa fa-fw fa-info-circle"></i>
                    </small>
                  </div>
                  <b-button variant="outline-primary" class="py-0" v-b-modal.combine-options-modal>
                    {{ trans('modify') }}
                  </b-button>
                  <combine-options-modal
                    what="activity"
                    :combine="amilia_combine"
                    @combine="amilia_combine = $event"
                    :allow_multiple="amilia_allow_multiple"
                    @allow_multiple="amilia_allow_multiple = $event"
                  ></combine-options-modal>
                </b-form-group>
              </div>
            </b-tab>

            <b-tab :title="filterTabTitle">
              <import-filters
                :type="recipient_list.type"
                v-model="filters"
                v-on:input="filterParticipants"
                :can-filter="canFilter"
              />
            </b-tab>
          </b-tabs>

          <template v-slot:footer>
            <b-row>
              <b-col>
                <em :class="{ 'text-danger': isError}">
                  <i class="fa fa-fw fa-spin fa-circle-notch" v-if="isLoading|isSaving"></i>
                  {{ status }}
                </em>
                <em v-if="filteredParticipants.length > maxParticipants" class="text-danger">
                  {{ trans('too_many_records_max').replace(':count', maxParticipants) }}
                </em>
                <div v-if="recipient_list.import_running"  class="text-danger">
                  <i class="fa fa-fw fa-circle-notch fa-spin"></i>
                  <em v-html="importRunningMessage"></em>
                </div>
              </b-col>
              <b-col sm="auto">
                <b-button variant="info" @click="diffWithBackend" :disabled="!canSave" v-if="isDev">
                  Diff
                </b-button>
                <b-button variant="primary" v-on:click="saveOptions" :disabled="!canSave">
                  {{ trans('save') }}
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-card>

        <div v-if="isDev" class="mt-2">
          <b-button variant="link" size="sm" class="text-info" v-b-modal.amilia-urls-modal>
            <i class="fa fa-fw fa-link"></i>
            Amilia URLs
          </b-button>
          <b-modal
            id="amilia-urls-modal"
            ok-only
            :ok-title="trans('close')"
          >
            <p v-for="a in getAmiliaUrls()" :key="a.id">
              <strong class="d-block">{{ a.name }}</strong>
              <code class="d-block" v-clipboard:copy="a.url" :title="trans('copy_to_clipboard')" v-b-tooltip.hover style="cursor: pointer;">{{ a.url }}</code>
            </p>
          </b-modal>
        </div>
      </b-col>

      <b-col :cols="leftLarge ? 4 : 8">
        <b-row>
          <b-col>
            <h5>
              {{ trans('recipients') }}
              <small>
                ({{ trans((filters.recipient_filter == 'guardians' ? 'guardian' : filters.recipient_filter)+'s').toLowerCase() }})
                <i class="fa fa-fw fa-info-circle text-muted" id="recipients_about"></i>
                <b-tooltip target="recipients_about" triggers="hover">
                  {{ trans('recipients_about') }}
                </b-tooltip>
              </small>
            </h5>
          </b-col>

          <b-col class="col-auto">
            <b-dropdown id="table-actions" variant="link" class="no-child-padding" right no-caret>
              <template v-slot:button-content>
                <i class="fa fa-fw fa-save"></i>
              </template>
              <b-dropdown-item @click="downloadCsvToFile">
                <i class="fa fa-fw fa-file-csv"></i>
                {{ trans('export_to_csv') }}
                <small class="text-muted">
                  <i class="fa fa-fw fa-info-circle" id="export_csv"></i>
                  <b-tooltip target="export_csv" triggers="hover">
                    {{ trans('export_to_csv_about') }}
                  </b-tooltip>
                </small>
              </b-dropdown-item>
              <b-dropdown-item @click="copyCsvToClipboard">
                <i class="fa fa-fw fa-copy"></i>
                {{ trans('copy_as_csv') }}
                <small class="text-muted">
                  <i class="fa fa-fw fa-info-circle" id="copy_csv"></i>
                  <b-tooltip target="copy_csv" triggers="hover">
                    {{ trans('copy_as_csv_about') }}
                  </b-tooltip>
                </small>
              </b-dropdown-item>
            </b-dropdown>
          </b-col>

        </b-row>

        <b-row class="my-2">
          <b-col>
            <b-input-group>
              <b-form-input type="search" v-model="search_temp" name="name" size="sm" :placeholder="trans('name') + ', ' + trans('email') + ', ' + trans('participant')" :disabled="isLoading || isSaving" @change="onClickSearch" @search="onClickSearch" @keydown.enter="onClickSearch" />
              <b-input-group-append>
                <b-button variant="primary" size="sm" @click="onClickSearch">
                  <i class="fa fa-fw fa-search"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col class="col-auto py-1">
            <b-form-checkbox v-model="show_excluded" size="sm" :disabled="isLoading || isSaving" :class="show_excluded ? 'text-danger' : ''" @change="onClickShowExcluded">
              <i class="fa fa-fw fa-user-times"></i>
              {{ trans('show_ones_excluded') }}
              ({{ (exclude_amilia_ids||[]).length }})
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-table
          id="recipients"
          ref="table"
          class="bg-white table-row-click"
          bordered
          small
          hover
          responsive
          show-empty
          :per-page="perPage"
          :current-page="currentPage"
          :fields="recipientsFields"
          :items="tableParticipants"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <h4 v-if="isLoading" align="center">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ trans('loading') }}
            </h4>
            <p v-if="!isLoading" align="center">{{ trans('no_participants_found') }}</p>
          </template>
          <template v-slot:cell(_no)="data">
            {{ data.value }}
            <b-button v-if="!show_excluded" variant="link" size="sm" class="p-0 text-muted" @click="onClickExclude(data.item)" :title="trans('exclude')">
              <i class="fa fa-fw fa-user-times"></i>
            </b-button>
            <b-button v-if="show_excluded" variant="link" size="sm" class="p-0 text-success" @click="onClickRestore(data.item)" :title="trans('restore')">
              <i class="fa fa-fw fa-user-check"></i>
            </b-button>
          </template>
          <template v-slot:cell(name)="data">
            {{ data.value }}
            <span class="badge badge-primary" v-if="data.item.children && data.item.children.length">
              {{ data.item.children.length }}
            </span>
            <i class="fa fa-fw fa-caret-right" v-if="!data.item._showDetails"></i>
            <i class="fa fa-fw fa-caret-down" v-if="data.item._showDetails"></i>
          </template>
          <template v-slot:row-details="data">
            <p class="ml-4 mb-2" v-if="data.item.registrations && data.item.registrations.length > 0">
              <i class="fa fa-fw fa-angle-double-right"></i>
              <strong>{{ trans('activity') }}:</strong>
              {{ activityToString(data.item.registrations[0]) }}
              <span v-if="data.item.registrations[0].is_cancelled" class="text-danger ml-1">
                <em>({{ trans('cancelled').toLowerCase() }})</em>
              </span>
              <small class="text-muted">
                {{ trans('registered') }}:
                {{ moment(data.item.registrations[0].registered_at).format('LLL') }}
              </small>
            </p>
            <p class="ml-4 mb-2">
              <i class="fa fa-fw fa-angle-double-right"></i>
              <strong>{{ trans('account_owner') }}:</strong>
              {{ data.item.account_owner_name }}, {{ data.item.account_owner_email }}
              <a class="btn btn-link p-0 ml-4" :href="`https://www.amilia.com/Clients/${lang}/${organization.amilia_slug}/ClientBilling/${data.item.account_id}`" target="_blank">
                {{ trans('account') }}
                <i class="fa fa-fw fa-external-link-alt"></i>
              </a>
            </p>
            <p class="ml-4 mb-2">
              <i class="fa fa-fw fa-angle-double-right"></i>
              <strong>{{ trans('participant') }}:</strong>
              {{ compact([data.item.participant_name, data.item.participant_email]).join(', ') }}
            </p>
            <p v-if="data.item.children && data.item.children.length" class="ml-4 mb-2">
              <i class="fa fa-fw fa-angle-double-right"></i>
              <strong>{{ trans('other_guardian') }}:</strong>
              {{ compact([data.item.other_guardian_name, data.item.other_guardian_email]).join(', ') }}
            </p>
            <p class="ml-4 mb-2" v-if="data.item.children && data.item.children.length">
              <i class="fa fa-fw fa-angle-double-right"></i>
              <strong>{{ trans('children') }}:</strong>
              {{ childrenToString(data.item.children) }}
            </p>
            <p class="ml-4 mb-2" v-if="data.item.children && data.item.children.length">
              <small class="text-muted">
                {{ data.item.children.length == 1 ? trans('family_account_child') : trans('family_account_children').replace(':count', data.item.children.length) }}
              </small>
              <small class="text-muted">{{ trans('amilia_account_about') }}</small>
            </p>
          </template>
          <template v-slot:cell(mobile)="data">
            {{ data.item.mobile }}
            <i class="fa fa-exclamation-triangle" :id="'invalid-mobile-'+data.item._no" v-if="!!data.item._mobileError"></i>
            <b-tooltip :target="'invalid-mobile-'+data.item._no" triggers="hover" v-if="!!data.item._mobileError">
              {{ data.item._mobileError }}
            </b-tooltip>
          </template>
          <template v-slot:cell(email)="data">
            {{ data.item.email }}
            <i class="fa fa-exclamation-triangle" :id="'invalid-email-'+data.item._no" v-if="!!data.item._emailError"></i>
            <b-tooltip :target="'invalid-email-'+data.item._no" triggers="hover" v-if="!!data.item._emailError">
              {{ data.item._emailError }}
            </b-tooltip>
          </template>
        </b-table>
        <div class="text-info" v-if="invalidRows > 0">
          <i class="fa fa-exclamation-triangle"></i>
          <small><em>
            {{ invalidRows }}
            {{ trans('ignore_invalid_recipient' + (invalidRows > 1 ? 's' : '')) }}.
          </em></small>
        </div>        <p class="text-danger" v-if="invalidCells > 0">
          <i class="fa fa-exclamation-triangle"></i>
          <small><em>
            {{ trans('invalid_cells_warning').replace(':count', invalidCells) }}
          </em></small>
        </p>
        <b-pagination
          :total-rows="filteredParticipants.length"
          :per-page="perPage"
          v-model="currentPage"
          aria-controls="recipients"
          align="center"
        />
      </b-col>
    </b-row>
    <br/>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import download from 'downloadjs/download'
  import ImportFilters from './ImportFiltersComponent'
  import CombineOptionsModal from './CombineOptionsModal'

  export default {
    props: {
      organization: Object,
      recipient_list: Object,
      hide_extra_rules: Boolean,
      rows: Number,
      ignoreDirtyCheck: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Treeselect,
      ImportFilters,
      CombineOptionsModal,
    },
    data() {
      let options = _.cloneDeep(this.recipient_list.amilia_live_list)
      if (options) {
        options.amilia_combine = this.recipient_list ? this.recipient_list.amilia_combine : false
        options.amilia_allow_multiple = this.recipient_list ? this.recipient_list.amilia_allow_multiple : false
      }
      return {
        options: options,
        trans: trans,
        moment: moment,
        lang: lang,
        isDev: _.isDev,
        compact: _.compact,
        // UI State
        status: trans('loading_programs'),
        isSaving: false,
        isLoading: false,
        isError: false,
        checkImporting: true,
        leftLarge: false,
        // Import from Amilia
        cache: {},
        participants: null,
        accountOwnerChildrenMap: {},
        activitiesMap: {},
        selectedProgramId: null,
        registration_status: this.recipient_list.amilia_live_list && this.recipient_list.amilia_live_list.registration_status ? this.recipient_list.amilia_live_list.registration_status : 'Active',
        registrationStatusOptions: [
          {value: 'Active', text: trans('registered')},
          {value: 'Cancelled', text: trans('cancelled')},
        ],
        programs: [
          {value: null, text: trans('select_a_program')},
        ],
        treeOptions: [],
        treeSelection: null,
        extra_rules: [],
        // Filters
        filters: {
          age_filter: 'no',
          age_min: 0,
          age_max: 99,
          birthday_filter: 'no',
          birthday_month: moment().startOf('month').format('YYYY-MM-DD'),
          gender_filter: 'no',
          recipient_filter: 'account_owner',
        },
        // Paginated table with filtered participants
        filteredParticipants: [],
        startCount: this.recipient_list && this.recipient_list.amilia_live_list ? this.recipient_list.amilia_live_list.participant_count : 0,
        maxParticipants: 4000,
        invalidCells: 0,
        invalidRows: 0,
        perPage: this.rows ? this.rows : 10,
        currentPage: 1,
        amilia_combine: this.recipient_list ? (this.recipient_list.amilia_combine || false) : false,
        amilia_allow_multiple: this.recipient_list ? (this.recipient_list.amilia_allow_multiple || false) : false,
        search_temp: null,
        search: null,
        show_excluded: false,
        exclude_amilia_ids: this.recipient_list && this.recipient_list.amilia_live_list ? this.recipient_list.amilia_live_list.exclude_amilia_ids : null,
      }
    },
    computed: {
      recipientsFields() {
        return _.compact([{
          key: '_no',
          label: 'no',
          headerTitle: trans('amilia_column_title'),
          sortable: true,
        }, {
          key: 'name',
          label: trans('name'),
          sortable: true,
        }, {
          key: 'mobile',
          label: trans('mobile'),
          sortable: true,
        }, {
          key: 'email',
          label: trans('email'),
          sortable: true,
        }, this.filters.recipient_filter == 'account_owner' || this.filters.recipient_filter == 'guardians' ? {
          key: 'participant',
          label: trans('participant'),
          formatter: (value, key, item) => {
            return item.participant_name
          },
        } : null, {
          key: 'gender',
          label: trans('gender'),
          formatter: (value) => {
            switch (value) {
              case 'Male':
                return trans('male')
              case 'Female':
                return trans('female')
              case 'NotSpecified':
                return trans('not_specified')
            }
          },
          headerTitle: trans('amilia_column_title'),
          sortable: true,
        }, {
          key: 'age',
          label: trans('age'),
          headerTitle: trans('amilia_column_title'),
          sortable: true,
        }, {
          key: 'date_of_birth',
          label: trans('birthday'),
          headerTitle: trans('amilia_column_title'),
          sortable: true,
          formatter: (value) => {
            if (!value) return null
            return moment(value).format('D MMM')
          },
        }, {
          key: 'is_child',
          label: trans('child'),
          formatter: (value) => {
            return value ? trans('yes') : trans('no')
          },
          headerTitle: trans('amilia_column_title'),
          sortable: true,
        }])
      },
      importRunningMessage() {
        return trans('import_running').replace(':url', `/organization/${this.organization.id}/list`)
      },
      canFilter() {
        return !this.isLoading && this.treeSelection && this.treeSelection.length > 0
      },
      canSave() {
        return this.canFilter && this.isDirty && !this.isSaving && this.filteredParticipants.length < this.maxParticipants &&
          !this.show_excluded
      },
      isDirty() {
        const keys = [
          'type', 'amilia_combine', 'amilia_allow_multiple', 'participant_count',
          'age_filter', 'age_max', 'age_min',
          'birthday_filter', 'birthday_month',
          'gender_filter', 'recipient_filter', 'registration_status',
          'program_id', 'activity_ids', 'category_ids', 'subcategory_ids', 'extra_rules',
        ]
        const serializedOptions = _.pick(this.serializeOptions(), keys)
        const options = _.pick(this.options, keys)
        return !_.isEqual(serializedOptions, options) || this.startCount != this.filteredParticipants.length
      },
      treeTitle() {
        return !this.isLoading ? trans('select_activities') : trans('please_wait')
      },
      filterTabTitle() {
        let str = '2. '+trans('filter')
        let count = 0
        if (this.filters.age_filter != 'no') count += 1
        if (this.filters.birthday_filter != 'no') count += 1
        if (this.filters.gender_filter != 'no') count += 1
        if (this.filters.recipient_filter != 'participant') count += 1
        if (count > 0) str += ' (' + count + ')'
        return str
      },
      tableParticipants() {
        return _.reduce(this.filteredParticipants || [], (result, p) => {
          let pass = true
          if (this.search) {
            pass = false
            let s = this.search.trim().toLowerCase()
            if (p.name) {
              p.name.split(' ').forEach(n => {
                if (n.trim().toLowerCase().indexOf(s) === 0) pass = true
              })
            }
            if (p.participant_name) {
              p.participant_name.split(' ').forEach(n => {
                if (n.trim().toLowerCase().indexOf(s) === 0) pass = true
              })
            }
            if (p.email && p.email.trim().toLowerCase().indexOf(s) === 0) pass = true
          }
          if (pass) result.push(p)
          return result
        }, [])
      },
    },
    watch: {
      amilia_combine() {
        this.filterParticipants()
      },
      amilia_allow_multiple() {
        this.filterParticipants()
      },
    },
    methods: {
      onClickShowExcluded() {
        this.filterParticipants()
      },
      onClickExclude(item) {
        if (!this.exclude_amilia_ids) this.exclude_amilia_ids = []
        if (this.exclude_amilia_ids.indexOf(item.id) === -1)
          this.exclude_amilia_ids.push(item.id)
        this.filterParticipants()
      },
      onClickRestore(item) {
        if (this.exclude_amilia_ids) {
          let index = this.exclude_amilia_ids.indexOf(item.id)
          if (index >= 0) this.exclude_amilia_ids.splice(index, 1)
        }
        this.filterParticipants()
      },
      onClickSearch() {
        this.currentPage = 1
        this.search = this.search_temp
      },
      onRowClick(item) {
        item._showDetails = !item._showDetails
        this.$refs.table.refresh()
      },
      activityToString(activity) {
        return _.uniq(_.compact([
          activity.program_name,
          activity.category_name,
          activity.subcategory_name,
          activity.team_name || activity.name || activity.activity_name,
          activity.group_name,
        ])).join(', ')
      },
      childToString(child) {
        let gender = child.gender == 'Male' ? trans('boy').toLowerCase() : (child.gender == 'Female' ? trans('girl').toLowerCase() : null)
        return _.compact([child.name, gender, child.age]).join(', ')
      },
      childrenToString(children) {
        return _.map(children, this.childToString).join('; ')
      },
      pickColumns(r) {
        let result = _.pick(r, ['name', 'mobile', 'email'])
        if (r.id !== undefined) result.amilia_id = r.id
        return result
      },
      onTreeSelectAll(index) {
        let treeOptions = index == null ? this.treeOptions : this.extra_rules[index].treeOptions
        let treeSelection = index == null ?
          (this.treeSelection || []) :
          (this.extra_rules[index].treeSelection || [])
        treeSelection.splice(0, treeSelection.length)
        treeOptions.forEach(option => {
          treeSelection.push(option.id)
        })
        if (index == null)
          this.treeSelection = treeSelection
        else
          this.extra_rules[index].treeSelection = treeSelection 
      },
      onTreeClearAll(index) {
        let treeSelection = index == null ?
          this.treeSelection :
          this.extra_rules[index].treeSelection
        if (treeSelection) treeSelection.splice(0, treeSelection.length)
      },
      onNewAddParticipantsRule() {
        this.extra_rules.push({
          index: this.extra_rules.length,
          type: 'add',
          selectedProgramId: null,
          registration_status: 'Active',
          treeOptions: [],
          treeSelection: null,
          participant_count: 0,
          filtered_count: 0,
        })
      },
      onNewRemoveParticipantsRule() {
        this.extra_rules.push({
          index: this.extra_rules.length,
          type: 'remove',
          selectedProgramId: null,
          registration_status: 'Active',
          treeOptions: [],
          treeSelection: null,
          participant_count: 0,
          filtered_count: 0,
        })
      },
      deleteRule(no) {
        this.extra_rules.splice(no, 1)
        let index = 0
        this.extra_rules.forEach(r => {
          r.index = index
          index += 1
        })
        this.filterParticipants()
      },
      ruleHelpText(rule) {
        return trans('found_participant' + (rule.participant_count > 1 ? 's' : '')).replace(':count', rule.participant_count) +
          '. ' +
          trans((rule.type == 'add' ? 'added' : 'removed') + '_participant' + (rule.filtered_count > 1 ? 's' : '')).replace(':count', rule.filtered_count) +
          '.'
      },
      copyCsvToClipboard() {
        _.copyToClipboard(_.convert(_.map(this.filteredParticipants, this.pickColumnsForExport), '\t'))
        this.$bvToast.toast(trans('csv_copied_to_clipboard_details'), {
          title: trans('csv_copied_to_clipboard'),
          autoHideDelay: 4000,
          variant: 'primary',
          solid: true,
        })
      },
      downloadCsvToFile() {
        let filename = this.recipient_list.name.replace(/\s+/g, '-').replace(/[^\w-]+/g,'') + '.csv'
        download(new Blob(["\uFEFF"+_.convert(_.map(this.filteredParticipants, this.pickColumnsForExport), ',')]), filename, 'text/plain')
      },
      serializeTreeSelection(treeSelection) {
        let category_ids = []
        let subcategory_ids = []
        let activity_ids = []
        if (treeSelection && treeSelection.length) {
          _.each(treeSelection, v => {
            let match = v.match(/^(c|s|a)([0-9]+)$/)
            if (!match || !match.length == 3) return true
            let id = parseInt(match[2], 10)
            if (isNaN(id)) return true
            switch (match[1]) {
              case 'c':
                category_ids.push(id)
                break
              case 's':
                subcategory_ids.push(id)
                break
              case 'a':
                activity_ids.push(id)
                break
            }
          })
        }
        return {
          category_ids: category_ids,
          subcategory_ids: subcategory_ids,
          activity_ids: activity_ids,
        }
      },
      pickColumnsForExport(r) {
        let dates = _.reduce(r.registrations, (dates, r) => {
          if (r.dropin_at) dates.push(moment(r.dropin_at).format('YYYY-MM-DD H:mm'))
          return dates
        }, [])
        let result = {
          'participant': r.participant_name,
          'gender': r.gender,
          'date of birth': r.date_of_birth,
          'account owner': r.account_owner_name,
          'email': r.email,
          'mobile': r.mobile
        }
        if (r.id !== undefined) result.amilia_id = r.id
        result['date of birth'] = result['date of birth'] ? moment(result['date of birth']).format('Y-M-D') : null
        const activity = r.registrations && r.registrations.length > 0 && this.activitiesMap[r.registrations[0].activity_id] ? this.activitiesMap[r.registrations[0].activity_id] : null
        if (activity) {
          result.activity = activity.name
          result.subcategory = activity.subcategory_name
          result.category = activity.category_name
          result.program = activity.program_name
          if (dates.length == 0) dates = _.map(activity.occurrences, o => {
            return moment(o.start).format('YYYY-MM-DD H:mm')
          })
        }
        for (var i = 0; i < dates.length; i++) {
          result['date_' + (i+1)] = dates[i]
        }
        return result
      },
      serializeParticipants() {
        return _.reduce(this.filteredParticipants, (participants, o) => {
          let activities = _.reduce(o.registrations || [], (activities, r) => {
            if (this.activitiesMap[r.activity_id] && !_.find(activities, {id: r.activity_id}))
              activities.push(this.activitiesMap[r.activity_id])
            return activities
          }, [])
          if (!this.amilia_allow_multiple && activities.length > 1) activities = [activities[activities.length-1]]
          return _.reduce(activities, (participants, activity) => {
            //const activity = o.registrations && o.registrations.length > 0 && this.activitiesMap[o.registrations[0].activity_id] ? this.activitiesMap[o.registrations[0].activity_id] : null
            let p = this.pickColumns(o)
            p.extra = {
              all_emails: o.all_emails,
              activity: activity,
              registrations: o.registrations,
              participant: {
                amilia_id: o.participant_id,
                name: o.participant_name,
                email: o.participant_email,
                mobile: o.participant_mobile,
                pickup_password: o.participant_pickup_password,
                friend: o.participant_friend,
              },
              account_owner: {
                amilia_id: o.account_owner_id,
                account_id: o.account_id,
                name: o.account_owner_name,
                email: o.account_owner_email,
                mobile: o.account_owner_mobile,
              },
              other_guardian: {
                amilia_id: o.other_guardian_id,
                name: o.other_guardian_name,
                email: o.other_guardian_email,
                mobile: o.other_guardian_mobile,
              },
              children: _.map(o.children, c => {
                return _.pick(c, ['amilia_id', 'name', 'date_of_birth', 'gender', 'registrations'])
              }),
              occurrences: _.reduce(activity && activity.occurrences ? activity.occurrences : [], (l, oc) => {
                let keep = false
                if (o.registrations) {
                  for (let i = 0; i < o.registrations.length; i++) {
                    const r = o.registrations[i]
                    if (r.dropin_occurrence_id == oc.id) keep = true
                    if (!r.dropin_occurrence_id) {
                      keep = true
                      break
                    }
                  }
                }
                if (keep) l.push(oc)
                return l
              }, []),
            }
            participants.push(p)
            return participants
          }, participants)
        }, [])
      },
      serializeOptions() {
        const ids = this.serializeTreeSelection(this.treeSelection)
        return _.extend({
          amilia_combine: this.amilia_combine,
          amilia_allow_multiple: this.amilia_allow_multiple,
          type: 'program',
          program_id: this.selectedProgramId,
          registration_status: this.registration_status,
          category_ids: ids.category_ids,
          subcategory_ids: ids.subcategory_ids,
          activity_ids: ids.activity_ids,
          participant_count: this.filteredParticipants.length,
          recipients: this.serializeParticipants(),
          exclude_amilia_ids: this.exclude_amilia_ids,
          extra_rules: this.extra_rules.map(rule => {
            return _.extend(this.serializeTreeSelection(rule.treeSelection), {
              type: rule.type,
              program_id: rule.selectedProgramId,
              registration_status: rule.registration_status,
              participant_count: rule.participant_count,
            })
          }),
        }, this.filters)
      },
      saveOptions() {
        let options = this.serializeOptions()
        let url = `/organization/${this.organization.id}/list/${this.recipient_list.id}/amilia_live_list`
        if (this.options) url += '/' + this.options.id
        const method = this.options ? 'patch' : 'post'

        this.status = trans('saving')
        this.isSaving = true
        this.isError = false
        this.checkImporting = false

        axios[method](url, options)
        .then(response => {
          this.options = response.data
          this.startCount = this.filteredParticipants.length
          this.isSaving = false
          this.checkImporting = true
          this.status = this.buildFilteredStatus()
          this.$emit('save', response.data)
        })
        .catch(error => {
          this.isSaving = false
          this.isError = true
          this.status = _.errorFromAjax(error)
        })
      },
      diffWithBackend() {
        const options = this.serializeOptions()
        const url = `/organization/${this.organization.id}/list/${this.recipient_list.id}/amilia_live_list/${this.options.id}/diff`
        this.status = 'Diffing...'
        this.isSaving = true
        this.isError = false
        axios.post(url, options)
        .then(response => {
          this.isSaving = false
          window.diff = response.data
          console.log(response.data)
        })
        .catch(error => {
          this.isSaving = false
          this.isError = true
          this.status = _.errorFromAjax(error)
        })
      },
      loadPrograms() {
        let url = '/organization/' + this.organization.id + '/amilia/programs'
        this.status = trans('loading_programs')
        this.isLoading = true
        this.isError = false
        return axios.get(url)
        .then(response => {
          this.isLoading = false
          if (!response.data || response.data.length == 0) {
            this.status = trans('no_programs')
            this.isError = true
            return
          }
          // Build the programs
          let hidden = []
          response.data.forEach(item => {
            let option = {
              value: item.id,
              text: item.name
            }
            if (item.archived) option.text += ` (${trans('archived').toLowerCase()})`
            if (item.visible)
              this.programs.push(option)
            else
              hidden.push(option)
          })
          if (hidden.length > 0) {
            this.programs.push({
              value: null,
              text: trans('visible_only_administrators'),
              disabled: true
            })
            hidden.forEach(option => {
              this.programs.push(option)
            })
          }
          this.status = trans('select_a_program')
        })
        .catch(error => {
          this.isLoading = false
          this.isError = true
          this.status = _.errorFromAjax(error)
        })
      },
      onProgramChange(no) {
        this.loadActivities(no).then(() => {
          this.loadParticipants(no)
        })
      },
      onRegistrationStatusChange(no) {
        this.loadParticipants(no)
      },
      fetchFromAmiliaApi(what, id, status) {
        if (what != 'activities' && what != 'participants')
          throw `Invalid what "${what}". Expecting either "activities" or "participants".`

        let key = what+id+(status || '')

        if (!id) this.cache[key] = {data: []}

        if (this.cache[key]) {
          return new Promise((resolve, reject) => {
            resolve({
              data: this.cache[key].data
            })
          })
        }

        let url = `/organization/${this.organization.id}/amilia/programs/${id}/${what}`
        if (status) url += `?status=${status}`
        return axios.get(url)
        .then(response => {
          if (response.data) this.cache[key] = {data: response.data}
            return response
        })
      },
      loadActivities(no) {
        let that = no === undefined ? this : this.extra_rules[no]
        this.status = trans('loading_activities')
        that.treeSelection = null
        this.isLoading = true
        this.isError = false
        return this.fetchFromAmiliaApi('activities', that.selectedProgramId)
        .then(response => {
          this.isLoading = false
          let activities = response.data
          _.mapAmiliaActivities(this.activitiesMap, response.data)
          // Build the treeview
          let tree = {}
          activities.forEach(function(a) {
            if (!tree[a.category_id])
              tree[a.category_id] = {
                id: 'c' + a.category_id,
                label: a.category_name,
                isDefaultExpanded: true,
                children: {}
              }
            if (!tree[a.category_id].children[a.subcategory_id])
              tree[a.category_id].children[a.subcategory_id] = {
                id: 's' + a.subcategory_id,
                label: a.subcategory_name,
                children: []
              }
            let name = a.name + ` - ${moment(a.start).format('ddd LT')}`
            if (a.is_hidden) name += ` (${trans('hidden').toLowerCase()})`
            if (a.is_cancelled) name += ` (${trans('cancelled').toLowerCase()})`
            tree[a.category_id].children[a.subcategory_id].children.push({
              id: 'a' + a.id,
              label: name,
              title: _.compact([
                a.schedule_summary,
                a.location,
                a.staff,
                a.start_date && a.end_date ? `${moment(a.start_date).format('LL')} - ${moment(a.end_date).format('LL')}` : null,
              ]).join(', '),
            })
          })
          tree = _.values(tree)
          tree.forEach(function(node) {
            node.children = _.values(node.children)
          })
          that.treeOptions = tree
          return response
        })
        .catch(error => {
          this.isLoading = false
          this.isError = true
          this.status = _.errorFromAjax(error)
        })
      },
      participantIsInTreeSelection(participant, treeSelection, registration_status) {
        if (!treeSelection || treeSelection.length == 0) return false
        let activityPass = false
        _.each(participant.registrations, r => {
          activityPass = _.intersection(
              treeSelection,
              ['a'+r.activity_id, 's'+r.subcategory_id, 'c'+r.category_id]
            ).length > 0 &&
            (r.is_cancelled && registration_status == 'Cancelled' || !r.is_cancelled && registration_status == 'Active')
          if (activityPass) return false
        })
        return activityPass
      },
      filterRegistrations(registrations) {
        if (!this.treeSelection || this.treeSelection.length == 0) return registrations
        return _.reduce(registrations, (l, r) => {
          let pass = false
          if (_.intersection(
              this.treeSelection,
              ['a'+r.activity_id, 's'+r.subcategory_id, 'c'+r.category_id]
              ).length > 0) {
            pass = true
          }
          this.extra_rules.forEach(rule => {
            if (_.intersection(
                rule.treeSelection,
                ['a'+r.activity_id, 's'+r.subcategory_id, 'c'+r.category_id]
              ).length > 0) pass = true
          })
          if (pass) l.push(r)
          return l
        }, [])
      },
      buildParticipantsFromCache() {
        this.participants = _.reduce(this.cache['participants'+this.selectedProgramId+this.registration_status]?.data || [], (l, p) => {
          if (this.participantIsInTreeSelection(p, this.treeSelection, this.registration_status)) l.push(p)
          return l
        }, [])
        this.extra_rules.forEach(rule => {
          let participants = _.reduce(this.cache['participants'+rule.selectedProgramId+rule.registration_status]?.data || [], (l, p) => {
            if (this.participantIsInTreeSelection(p, rule.treeSelection, rule.registration_status)) l.push(p)
            return l
          }, [])
          rule.participant_count = participants.length
          rule.filtered_count = 0
          if (rule.type == 'add') {
            const ids = _.map(this.participants, 'id')
            participants.forEach(p => {
              if (ids.indexOf(p.id) === -1) {
                this.participants.push(p)
                rule.filtered_count += 1
              }
            })
          }
          else if (rule.type == 'remove') {
            const ids = _.map(participants, 'id')
            this.participants = _.reduce(this.participants, (l, p) => {
              if (ids.indexOf(p.id) === -1) {
                l.push(p)
              } else {
                rule.filtered_count += 1
              }
              return l
            }, [])
          }
        })
        this.accountOwnerChildrenMap = {}
        _.mapAmiliaChildren(this.accountOwnerChildrenMap, this.participants)
      },
      loadParticipants(no) {
        let that = no === undefined ? this : this.extra_rules[no]
        this.status = trans('loading_participants')
        this.isLoading = true
        this.isError = false
        this.participants = null
        return this.fetchFromAmiliaApi('participants', that.selectedProgramId, that.registration_status || 'Active')
        .then(response => {
          this.isLoading = false
          this.buildParticipantsFromCache()
          this.filterParticipants()
          return response
        })
        .catch(error => {
          this.isLoading = false
          this.isError = true
          this.status = _.errorFromAjax(error)
        })
      },
      filterParticipants() {
        if (!_.isArray(this.participants)) return

        if (!this.treeSelection || this.treeSelection.length == 0) {
          this.status = trans('select_activities')
        }
        for (var i = 0; i < this.extra_rules.length; i++) {
          const rule = this.extra_rules[i]
          if (!rule.treeSelection || rule.treeSelection.length == 0) {
            this.status = trans('select_activities')
          }
        }

        this.buildParticipantsFromCache()

        let filteredParticipants = []
        this.invalidCells = 0
        this.invalidRows = 0

        let no = 1
        let usedMobiles = []
        let usedEmails = []
        this.participants.forEach(participant => {
          if (participant.participant_id === undefined) participant.participant_id = participant.id
          if (participant.participant_name === undefined) participant.participant_name = participant.name
          if (participant.participant_email === undefined) participant.participant_email = participant.email
          if (participant.participant_mobile === undefined) participant.participant_mobile = participant.mobile
          if (participant.participant_pickup_password === undefined) participant.participant_pickup_password = participant.pickup_password
          if (participant.participant_friend === undefined) participant.participant_friend = participant.friend

          let excluded = this.exclude_amilia_ids ? this.exclude_amilia_ids.indexOf(participant.id) >= 0 : false

          const addp = (p) => {
            p._no = no
            p._cellVariants = {}
            p._rowVariant = null
            p._mobileError = null
            p._emailError = null
            p._showDetails = false
            p._exlcuded = excluded
            let mobileExists = false
            let emailExists = false
            let mobileDuplicate = false
            let emailDuplicate = false
            // Validate/clean/format mobile
            let number = (p.mobile||'').replace(/\D/g,'').replace(/^1/, '')
            if (number.length == 10) {
              mobileExists = true
              p.mobile = number.substr(0, 3) + '-' +
                number.substr(3, 3) + '-' +
                number.substr(6, 4)
              if (this.amilia_combine) {
                if (usedMobiles[p.mobile] === undefined) {
                  usedMobiles[p.mobile] = no
                } else {
                  mobileDuplicate = true
                }
              }
            } else {
              this.invalidCells += 1
              p._cellVariants.mobile = 'danger'
            }

            // Validate/clean/format email
            let email = (p.email || '').replace(/\s/, '');
            if (_.validateEmail(email) === true) {
              emailExists = true
              p.email = email
              if (this.amilia_combine) {
                if (usedEmails[p.email] === undefined) {
                  usedEmails[p.email] = no
                } else {
                  emailDuplicate = true
                }
              }
            } else {
              this.invalidCells += 1
              p._cellVariants.email = 'danger'
            }

            if (mobileDuplicate && !emailExists ||
              emailDuplicate && !mobileExists ||
              mobileDuplicate && emailDuplicate) {
                this.invalidRows += 1
                p._rowVariant = 'info'
                if (mobileDuplicate)
                  p._mobileError = trans('duplicate_row_num').replace(':row', usedMobiles[p.mobile]);
                else
                  p._emailError = trans('duplicate_row_num').replace(':row', usedEmails[p.email]);
            } else if (!emailExists && !mobileExists) {
                this.invalidRows += 1
                p._rowVariant = 'info'
                p._mobileError = trans('missing_email_mobile').replace(':row', usedMobiles[p.mobile]);
            }

            if (mobileDuplicate && emailExists) {
              this.invalidCells += 1
              p._cellVariants.mobile = 'danger'
              p._mobileError = trans('duplicate_row_num').replace(':row', usedMobiles[p.mobile]);
            }
            if (emailDuplicate && mobileExists) {
              this.invalidCells += 1
              p._cellVariants.email = 'danger'
              p._emailError = trans('duplicate_row_num').replace(':row', usedEmails[p.email]);
            }
            
            p.children = this.amilia_combine ?
              _.values(this.accountOwnerChildrenMap[p.account_owner_id] || {}) :
              _.compact([_.reduce(this.accountOwnerChildrenMap[p.account_owner_id] || {}, (same, child) => {
                if (child.amilia_id == p.participant_id) same = child
                return same
              }), null])
            filteredParticipants.push(p)
            no += 1
          }

          // Filters
          let agePass = this.filters.age_filter == 'no' ||
            this.filters.age_filter == 'children' && participant.is_child ||
            this.filters.age_filter == 'adults' && !participant.is_child ||
            this.filters.age_filter == 'range' && participant.age != null && participant.age >= this.filters.age_min && participant.age <= this.filters.age_max

          let bdayPass = this.filters.birthday_filter == 'no' ||
            participant.date_of_birth != null && moment(this.filters.birthday_month).format('M') == moment(participant.date_of_birth).format('M')

          let genderPass = this.filters.gender_filter == 'no' ||
            this.filters.gender_filter.charAt(0) == (participant.gender||' ').charAt(0).toLowerCase()

          let excludePass = this.show_excluded && excluded ||
            !this.show_excluded && !excluded

          if (agePass && bdayPass && genderPass && excludePass) {
            let p = _.clone(participant)
            p.registrations = this.filterRegistrations(participant.registrations)
            if (this.filters.recipient_filter == 'account_owner' || this.filters.recipient_filter == 'guardians') {
              //p.id = participant.account_owner_id
              p.name = participant.account_owner_name
              p.email = participant.account_owner_email
              p.mobile = participant.account_owner_mobile
            }
            addp(p)

            if (this.filters.recipient_filter == 'guardians' && (participant.other_guardian_email || participant.other_guardian_mobile)) {
              let g = _.clone(participant)
              g.registrations = this.filterRegistrations(participant.registrations)
              g.id = participant.other_guardian_id
              g.name = participant.other_guardian_name
              g.email = participant.other_guardian_email
              g.mobile = participant.other_guardian_mobile
              addp(g)
            }
          }
        })
        this.filteredParticipants = filteredParticipants
        this.status = this.buildFilteredStatus() 
      },
      buildFilteredStatus() {
        //let valid = this.filteredParticipants.length - this.invalidRows
        let valid = this.serializeParticipants().length - this.invalidRows
        let count = this.filteredParticipants.length
        let str = trans('valid_recipient' + (valid > 1 ? 's' : '') + '_count').replace(':count', valid)
        str += ' ' + trans('of') + ' ' + count + ' ' + trans('participant' + (count > 1 ? 's' : '')).toLowerCase()
        return str
      },
      hydrateTreeSelection(rule, options, index) {
        rule.selectedProgramId = options.program_id
        rule.registration_status = options.registration_status || 'Active'
        if (rule.selectedProgramId) {
          this.loadActivities(index >= 0 ? index : undefined).finally(() => {
            rule.treeSelection = _.union(
              _.map(options.category_ids, function(id) {return 'c' + id}),
              _.map(options.subcategory_ids, function(id) {return 's' + id}),
              _.map(options.activity_ids, function(id) {return 'a' + id}),
            )
            this.loadParticipants(index >= 0 ? index : undefined).finally(() => {
              index += 1
              if (index < this.options.extra_rules.length) {
                options = this.options.extra_rules[index]
                rule = {
                  index: index,
                  type: options.type,
                  selectedProgramId: options.program_id,
                  registration_status: options.registration_status || 'Active',
                  participant_count: options.participant_count,
                  filtered_count: 0,
                  treeOptions: [],
                  treeSelection: null,
                }
                this.extra_rules.push(rule)
                this.hydrateTreeSelection(rule, options, index)
              }
            })
          })
        }
      },
      getAmiliaUrls() {
        return _.reduce(this.tableParticipants, (map, p) => {
          if (!!p.registrations && !!p.registrations[0] && !map[p.registrations[0].activity_id]) {
            map[p.registrations[0].activity_id] = {
              name: p.registrations[0].activity_name,
              url: `https://www.amilia.com/api/v3/${window.lang}/org/${this.organization.amilia_slug}/Activities/${p.registrations[0].activity_id}/Persons?showRegistrations=true`,
            }
          }
          return map
        }, {})
      },
    },
    mounted() {
      window.amiliaImport = this
      if (this.options) {
        // Hydrate
        this.filters = _.pick(this.options, [
          'age_filter', 'age_min', 'age_max',
          'birthday_filter', 'birthday_month',
          'gender_filter',
          'recipient_filter',
        ])
        this.loadPrograms().finally(() => {
          this.hydrateTreeSelection(this, this.options, -1)
        })
      } else {
        this.loadPrograms()
      }
      if (!this.ignoreDirtyCheck)
        window.addEventListener('beforeunload', (e) => {
          if(this.isDirty) {
            e.preventDefault()
            e.returnValue = ''
          }
        })
    },
  }
</script>
